import { SceneDescriptionConstants } from '../store/sceneDescription.constants'

export const sceneDescriptionSchemas = [
  // {
  //   inputKey: SceneDescriptionConstants.SET_SCENE_DESCRIPTION,
  //   isNumber: false,
  //   type: 'object',
  //   properties: {
  //     SET_SCENE_DESCRIPTION: {
  //       type: 'string',
  //       pattern: '^([\x20-\x7F]){1,4000}$',
  //     },
  //   },
  //   additionalProperties: false,
  //   required: ['SET_SCENE_DESCRIPTION'],
  //   errorMessage: {
  //     properties: {
  //       SET_SCENE_DESCRIPTION: 'Must be alphanumeric with max length of 4000',
  //     },
  //   },
  // },
  {
    inputKey: SceneDescriptionConstants.SET_NUM_PTS_SCENE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_NUM_PTS_SCENE: {
        type: 'number',
        minimum: 0,
        maximum: 999,
      },
    },
    additionalProperties: false,
    required: ['SET_NUM_PTS_SCENE'],
    errorMessage: {
      properties: {
        SET_NUM_PTS_SCENE: 'Must be <= 999',
      },
    },
  },
  {
    inputKey: SceneDescriptionConstants.SET_LAWNUM,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LAWNUM: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,40}$',
      },
    },
    additionalProperties: false,
    required: ['SET_LAWNUM'],
    errorMessage: {
      properties: {
        SET_LAWNUM: 'Must be alphanumeric with max length of 40',
      },
    },
  },
  {
    inputKey: SceneDescriptionConstants.SET_FIRENUM,
    isNumber: false,
    type: 'object',
    properties: {
      SET_FIRENUM: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,40}$',
      },
    },
    additionalProperties: false,
    required: ['SET_FIRENUM'],
    errorMessage: {
      properties: {
        SET_FIRENUM: 'Must be alphanumeric with max length of 40',
      },
    },
  },
  // {
  //   inputKey: SceneDescriptionConstants.SET_BELONGINGS,
  //   isNumber: false,
  //   type: 'object',
  //   properties: {
  //     SET_BELONGINGS: {
  //       type: 'string',
  //       pattern: '^([\x20-\x7F]){1,2000}$',
  //     },
  //   },
  //   additionalProperties: false,
  //   required: ['SET_BELONGINGS'],
  //   errorMessage: {
  //     properties: {
  //       SET_BELONGINGS: 'Must be alphanumeric with max length of 2000',
  //     },
  //   },
  // },
  // {
  //   inputKey: SceneDescriptionConstants.SET_STRETCHER_PURPOSE_DESCR,
  //   isNumber: false,
  //   type: 'object',
  //   properties: {
  //     SET_STRETCHER_PURPOSE_DESCR: {
  //       type: 'string',
  //       pattern: '^([\x20-\x7F]){1,200}$',
  //     },
  //   },
  //   additionalProperties: false,
  //   required: ['SET_STRETCHER_PURPOSE_DESCR'],
  //   errorMessage: {
  //     properties: {
  //       SET_STRETCHER_PURPOSE_DESCR: 'Must be alphanumeric with max length of 200',
  //     },
  //   },
  // },
]
